import { render } from "./SpreadSheet.vue?vue&type=template&id=796b0fd3&scoped=true"
import script from "./SpreadSheet.vue?vue&type=script&lang=js"
export * from "./SpreadSheet.vue?vue&type=script&lang=js"

import "./SpreadSheet.vue?vue&type=style&index=0&id=796b0fd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796b0fd3"]])

export default __exports__